import { render } from "./password-strength-component.vue?vue&type=template&id=36724e77&scoped=true"
import script from "./password-strength-component.vue?vue&type=script&lang=js"
export * from "./password-strength-component.vue?vue&type=script&lang=js"

import "./password-strength-component.vue?vue&type=style&index=0&id=36724e77&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36724e77"]])

export default __exports__